import Route from '@ember/routing/route';
import { set } from '@ember/object';
import { service } from '@ember/service';

export default class TasksSummaryRoute extends Route {
  @service navbarSettings;
  @service taskService;

  beforeModel() {
    set(this, 'navbarSettings.title', 'Tasks Summary');
  }

  model() {
    return this.taskService.load();
  }
}
